const createPlusLoadModalSelector = (state: any) => state.plusLoadModalStore

export default createPlusLoadModalSelector
